import React from 'react';
import classnames from 'classnames';
import * as mobxReact from 'mobx-react';
import { IOrganizationDetailsDTO } from '../../../../../api/organizations.dao';
import DefaultButton from '../../../../global/default-button/default-button';
import { AttendeeGroupColumn } from '../../../../global/attendee-group-column/attendee-group-column';

import './organizations-list-item.scss';
import { HighlightedSearchResult } from '../../shared/highlighted-search-result/highlighted-search-result';
import { FormattedMessage } from 'react-intl';
import Text from '../../../../global/text/text';

interface IOrganizationListItemProps {
    organizer: IOrganizationDetailsDTO;
    isSelected: boolean;
    handleEditClick: (organizationId: number) => void;
    editAttendee: (attendeeId) => void;
    onAttendeeHovered: (organizationId: number) => void;
    isAttendeesHovered: boolean;
    searchQuery?: string;
    handleAddAttendeeClick: (organizationId: number) => void;
    isAttendeeEditable: boolean;
    canCreateAttendee: boolean;
    canEditOrganization: boolean;
}

const OrganizationsListItem = mobxReact.observer((props: IOrganizationListItemProps) => {

    const {
        isSelected,
        handleEditClick,
        onAttendeeHovered,
        isAttendeesHovered,
        searchQuery,
        organizer,
        handleAddAttendeeClick,
        isAttendeeEditable,
        canCreateAttendee,
        canEditOrganization,
    } = props;
    const {
        name,
        organizationTicker,
        organizationType,
        attendees,
        organizationId,
        chaperones
    } = organizer;

    const onEditClick = () => handleEditClick(organizationId);

    const cellEffectClasses = classnames('organizations-attendees-list-item__cell', {
        'active': isSelected,
        'hoverable': !isSelected && !isAttendeesHovered,
    });

    const openEditAttendeeModal = attendeeId => {
        props.editAttendee(attendeeId);
    };

    const handleHoverAttendee = () => {
        onAttendeeHovered(organizationId);
    };

    const handleHoverOutAttendee = () => {
        onAttendeeHovered(null);
    };

    return (
        <tr className='attendees-list-item'>
        {
            [
                {
                    className: classnames(cellEffectClasses, 'organizations-attendees-list-item__organization-name'),
                    value: name
                },
                {
                    className: classnames(cellEffectClasses),
                    value: organizationType
                },
                {
                    className: classnames(cellEffectClasses),
                    value: organizationTicker
                },

            ].map(({value, className}, i) => {
                return <HighlightedSearchResult
                        key={i}
                        value={value}
                        className={className}
                        searchQuery={searchQuery}
                        cellEffectClasses={cellEffectClasses}
                        onDoubleClick={canEditOrganization ? onEditClick : undefined}
                    />;
            })
        }
            <td className={classnames(cellEffectClasses)} >
                {
                    (chaperones || [])
                        .slice()
                        .sort((a, b) => a.lastName.localeCompare(b.lastName))
                        .map(({ username, firstName, lastName }) => {
                            const attendeeInfo = firstName + ' ' + lastName;

                            return (
                                <div
                                    key={`${organizationId}_${username}`}
                                    className='attendee-list-item attendee-group-column attendee-group-item'
                                >
                                    <Text
                                        tag='div'
                                        className='attendee-list-item__text'
                                        message={attendeeInfo}
                                        withEllipsis
                                    />
                                </div>
                            );
                        })
                }
            </td>
            <td
                className={`organizations-attendees-list-item__button-container ${cellEffectClasses}`}
                onDoubleClick={canEditOrganization ? onEditClick : undefined}
            >
                {canEditOrganization && (
                    <DefaultButton
                        className='visible-while-hovered'
                        modifier='slim'
                        text='Edit'
                        onClick={onEditClick}
                    />
                )}
            </td>
            <td className='organizations-attendees-list-item hoverable' colSpan={2} onMouseOver={handleHoverAttendee} onMouseOut={handleHoverOutAttendee}>
                <AttendeeGroupColumn
                    attendees={attendees}
                    searchValue={searchQuery}
                    onEdit={openEditAttendeeModal}
                    isEditable={isAttendeeEditable}
                />
                { canCreateAttendee && (
                    <DefaultButton
                        className='visible-while-hovered add-attendee-btn'
                        modifier='slim'
                        text={
                            <FormattedMessage
                                id='oe.attendee.addAttendee'
                                description='Button text'
                                defaultMessage='+ Add Attendee'
                            />
                        }
                        onClick={() => handleAddAttendeeClick(organizationId)}
                    />
                )}
            </td>
        </tr>
    );
});

export { OrganizationsListItem };
